import { render } from "./VerticalEllipsis.vue?vue&type=template&id=5ad7104f&scoped=true"
import script from "./VerticalEllipsis.vue?vue&type=script&lang=js"
export * from "./VerticalEllipsis.vue?vue&type=script&lang=js"

import "./VerticalEllipsis.vue?vue&type=style&index=0&id=5ad7104f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad7104f"]])

export default __exports__